import $ from "jquery";

const filterName = "attestationSearchFilters";
let sortColumn;
let sortColumnIndex;
let sortOrder;
let attestationsSearchFilters;
let attestationsTable; //putting this here so I have a reference. Otherwise calling Datatable() seems to recreate it?

function init() {
    sortColumn = "";
    sortColumnIndex = 0;
    sortOrder = false;
}

function doSetup() {
    if (typeof Storage !== "undefined" &&
        sessionStorage.getItem(filterName) !== null) {
        attestationsSearchFilters = JSON.parse(sessionStorage.getItem(filterName));
    } else {
        setFilters();
    }
    setFieldsToFilter(attestationsSearchFilters);
}

function setFilters() {
    const searchFilter = {
        keyword: $("#searchKeyword").val(),
        activeOnly: $("#searchActiveOnly").is(":checked"),
        globalOnly: $("#searchGlobalOnly").is(":checked"),
        startDate: $("#searchDateRangeStart").val(),
        endDate: $("#searchDateRangeEnd").val(),
        typeIds: [],
        currentPage: 1,
        sortColumn: sortColumn,
        sortColumnIndex: sortColumnIndex,
        desc: sortOrder
    };

    $("[typeId]:checked").each(function() {
        searchFilter.typeIds.push($(this).attr("typeId"));
    });

    if (typeof Storage !== "undefined") {
        sessionStorage.setItem(filterName, JSON.stringify(searchFilter));
    }

    attestationsSearchFilters = searchFilter;
    putFilterInStorage();

    return attestationsSearchFilters;
}

function setFieldsToFilter() {
    $("#searchKeyword").val(attestationsSearchFilters.keyword);
    $("#searchActiveOnly").prop("checked", attestationsSearchFilters.activeOnly);
    $("#searchGlobalOnly").prop("checked", attestationsSearchFilters.globalOnly);
    $("#dateRangeStart").val(attestationsSearchFilters.dateRangeStart);
    $("#dateRangeEnd").val(attestationsSearchFilters.dateRangeEnd);
    attestationsSearchFilters.typeIds.forEach(function (id) {
        $("input[typeId='" + id + "']").prop("checked", true);
    });
    const sortColumn = attestationsSearchFilters.sortColumn;
    const sortColumnIndex = attestationsSearchFilters.sortColumnIndex;
    const sortOrder = attestationsSearchFilters.desc;
    setSortOrder(sortColumn, sortColumnIndex, sortOrder);
}

function setSortOrder(sortColumn, sortColumnIndex, sortOrder) {
    if (sortColumn !== "undefined" && sortColumn !== "") {
        return;
    }
    if (typeof attestationsTable === "undefined") {
        return;
    }
    if (sortColumn !== null && sortColumnIndex > 0) {
        if (sortOrder) {
            attestationsTable.columns[sortColumnIndex].addClass("sorting_desc");
        } else {
            attestationsTable.columns[sortColumnIndex].addClass("sorting_asc");
        }
    }
}

function getFilters() {
    if (attestationsSearchFilters === "undefined") {
        attestationsSearchFilters = setFilters();
    }
    return attestationsSearchFilters;
}

function getQueryStringFilters() {
    const filters = setFilters();
    for (const key in filters) {
        if (!filters[key]) {
            delete filters[key];
        }
    }
    return filters;
}

function clearFilters() {
    $("#searchKeyword").val("");
    $("#searchFilters :input").each(function() {
        switch (this.type) {
            case "text":
                $("#searchKeyword, #searchNonNaStateInput").val("");
                break;
            case "textarea":
                $(this).val("");
                break;
            case "checkbox":
                if (this.disabled !== true) $(this).prop("checked", false);
                $("#searchActive").prop("checked", true);
                $("#searchExpired").prop("checked", true);
                break;
            case "radio":
                this.checked = false;
                break;
        }
    });

    setFilters();
    putFilterInStorage();
}

function setSort(paramSortColumn, paramSortColumnIndex, paramSortOrder) {
    sortColumn = paramSortColumn;
    sortColumnIndex = paramSortColumnIndex;
    sortOrder = paramSortOrder;
    setFilters();
    putFilterInStorage();
}

function setAttestationsTable(paramattestationstable) {
    attestationsTable = paramattestationstable;
}

function putFilterInStorage() {
    if (typeof Storage !== "undefined") {
        sessionStorage.setItem(filterName, JSON.stringify(attestationsSearchFilters)
        );
    }
}

export const attestationsDashboardFilters = {
    init: init,
    getFilters: getFilters,
    setFilters: setFilters,
    clearFilters: clearFilters,
    getQueryStringFilters: getQueryStringFilters,
    setSort: setSort,
    setAttestationsTable: setAttestationsTable,
    doSetup: doSetup
};
